import React from "react";
import { motion } from "framer-motion";
import portfolioData from "../../data/mock";
import { Badge } from "../ui/badge";

const SkillsGrid = () => {
  const { skills } = portfolioData;

  const skillIcons = {
    Terraform: "TF",
    Kubernetes: "K8S",
    Docker: "DKR",
    Helm: "HLM",
    AWS: "AWS",
    Azure: "AZ",
    GCP: "GCP",
    Jenkins: "JNK",
    "CI/CD": "CI",
    Python: "PY",
    DevSecOps: "SEC",
    "Infrastructure as Code": "IaC"
  };

  return (
    <section id="skills" className="relative py-28 bg-zinc-950">
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-zinc-800 to-transparent" />

      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-emerald-400" />
            <span className="text-emerald-400 text-sm font-medium tracking-wider uppercase">
              Skills
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-2">
            Technical Toolkit
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {skills.map((skill, index) => (
            <motion.div
              key={skill}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.06 }}
              className="group relative p-5 rounded-xl border border-zinc-800/60 bg-zinc-900/20 hover:border-emerald-500/30 hover:bg-zinc-900/50 transition-all duration-300 cursor-default"
            >
              <div className="text-xs font-mono text-emerald-400/70 mb-3 tracking-wider">
                {skillIcons[skill] || skill.substring(0, 3).toUpperCase()}
              </div>
              <h3 className="text-white text-sm font-medium">{skill}</h3>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="mt-10 flex flex-wrap gap-2"
        >
          {[
            "GitHub Enterprise",
            "GitLab",
            "JFrog",
            "Grafana",
            "New Relic",
            "Bash",
            "IAM & RBAC",
            "AWS Secrets Manager",
            "Agentic AI",
            "RAG",
            "Agile / SDLC"
          ].map(
            (tool) => (
              <Badge
                key={tool}
                variant="outline"
                className="text-zinc-500 border-zinc-800 hover:text-zinc-300 hover:border-zinc-600 text-xs font-normal transition-colors duration-200"
              >
                {tool}
              </Badge>
            )
          )}
        </motion.div>
      </div>
    </section>
  );
};

export default SkillsGrid;
